<template>
  <div class="w-full h-fit pb-10 lg:sticky top-20 flex flex-col gap-3">
    <RightSideTabs />
    <KeepAlive>
      <component :is="selectedComponent" />
    </KeepAlive>
    <FeaturedVideo />
    <HomeAnnouncements />
    <div class="">
      <GroupListSide></GroupListSide>
    </div>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from "vue";
import RightSideTabs from "./partials/RightSideTabs.vue";
import { useHomeTabsStore } from "@/stores/home/useHomeTabs.store";
import { storeToRefs } from "pinia";
import { computed, onMounted } from "vue";
import GroupListSide from "../groups/GroupListSide.vue";
import HomeAnnouncements from "../home/announcements/HomeAnnouncements.vue";
import HomeReportSummary from "@/components/new-home/HomeReportSummary.vue";

const HomeEventsAndReminders = defineAsyncComponent(() =>
  import("./events-and-reminders/HomeEventsAndReminders.vue")
);

const FeaturedVideo = defineAsyncComponent(() =>
  import("./featured-video/FeaturedVideo.vue")
);

const homeTabStore = useHomeTabsStore();
const { selectedRightSectionTab } = storeToRefs(homeTabStore);

const selectedComponent = computed(() => {
  if (selectedRightSectionTab.value === "report_summary") {
    return HomeReportSummary;
  }
  return HomeEventsAndReminders;
});

onMounted(() => {
  if (selectedRightSectionTab.value === "my_videos") {
    selectedRightSectionTab.value = "report_summary";
  }
});
</script>

<style lang="scss" scoped></style>
